import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import H3 from '../../atoms/title/H3';
import CloseButton from '../../atoms/modal/CloseButton';
import { StyledContainer } from '../../atoms/StyledContainer';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
import { useWatchEscapeButton } from '../../hooks/useWatchEscapeButton';
import * as styled from './Modal.styled';
const portalId = 'portal';
const Modal = ({ title, children, open, onClose, maxWidth, 'data-testid': testId, }) => {
    useWatchEscapeButton({
        when: () => open,
        then: () => onClose(),
    });
    const onBackDropClickHandler = () => onClose();
    const onCloseClickHandler = () => onClose();
    let modalRoot = document.getElementById(portalId);
    if (!modalRoot) {
        modalRoot = document.createElement('div');
        modalRoot.id = portalId;
        document.body.appendChild(modalRoot);
    }
    const elRef = useRef(null);
    if (!elRef.current) {
        elRef.current = document.createElement('div');
    }
    useEffect(() => {
        modalRoot.appendChild(elRef.current);
        return () => modalRoot.removeChild(elRef.current);
    }, []);
    return ReactDOM.createPortal(_jsxs(StyledContainer, { "data-testid": testId, children: [_jsx(styled.Backdrop, { onClick: onBackDropClickHandler, open: open }), _jsx(styled.Modal, { open: open, maxWidth: maxWidth, children: _jsxs(styled.ContentContainer, { children: [_jsxs(styled.Header, { children: [_jsx(H3, { children: title }), _jsx(CloseButton, { "data-testid": `${testId}__close-button`, onClick: onCloseClickHandler })] }), _jsx(styled.Content, { children: children })] }) })] }), elRef.current);
};
const ModalActionsRoot = ({ children }) => {
    return (_jsxs(Flex, { children: [_jsx(Flex.Spacer, {}), children] }));
};
const ModalSecondaryAction = ({ type = 'button', textAlign = 'center', transparent = true, ...otherProps }) => (_jsx(Button, { type: type, textAlign: textAlign, transparent: transparent, ...otherProps }));
const ModalPrimaryAction = ({ type = 'button', secondary = true, textAlign = 'center', ...otherProps }) => (_jsx(Button, { type: type, secondary: secondary, textAlign: textAlign, ...otherProps }));
const ModalActions = Object.assign(ModalActionsRoot, {
    Primary: ModalPrimaryAction,
    Secondary: ModalSecondaryAction,
});
export default Object.assign(Modal, {
    Actions: ModalActions,
});
